import PropTypes from 'prop-types'
import React from 'react'
import { ReactComponent as SvgIcon } from '@fortawesome/fontawesome-pro/svgs/light/clipboard.svg'
import BaseIcon from '../../BaseIcon'

const Clipboard = ({ className }) => {
	return <BaseIcon component={SvgIcon} className={className} viewBox="0 0 384 512" />
}

Clipboard.propTypes = {
	className: PropTypes.string,
}

Clipboard.defaultProps = {
	className: null,
}
export default Clipboard
